/**
* @name: msg-detal-win
* @author: weiyong
* @date: 2023-10-08 12:56
* @description：msg-detal-win
* @update: 2023-10-08 12:56
*/
<template>
  <div  class="msg-detal-win" v-if="dialogVisible">
    <Modal
      :width="winWidth"
      :maskClosable="false"
      wrapClassName="noPaddingModal"
      :footer="null"
      v-model:visible="dialogVisible"
      :title="winTemConfig.winTitle"
    >
      <div class="win-body"  :style="winBodySty">
          <a-skeleton  v-if="loading" :paragraph="{ rows: 24 }" />
          <iframe class="wh100b" v-show="!loading" @load="loadPage"  :src="iframeUrl"></iframe>
      </div>
    </Modal>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "msg-detal-win",
});
</script>

<script lang="ts" setup>
import {Modal} from 'ant-design-vue'
import {useI18n} from "vue-i18n";
import {defineEmits} from "vue";
import {useVModel} from "@vueuse/core";

const { t } = useI18n();

const props:any=defineProps({
  visible:{},
  winTemConfig:{
    type:Object,
    default:function (){
      return {}
    }
  }
})
const {winTemConfig}=toRefs(props);

const emits = defineEmits(['update:visible']);
const dialogVisible = useVModel(props, 'visible', emits);

/**
 * 宽度
 */
const winWidth=computed(()=>{
    if(unref(winTemConfig).winWidth&&unref(winTemConfig).winWidth.indexOf("%")>=0){
      return document.body.clientWidth*(parseFloat(unref(winTemConfig).winWidth)/100)+"px";
    }else{
      return  document.body.clientWidth+"px";
    }
})

/**
 * 高度
 */
const winBodySty=computed(()=>{
  const sty={};
  if(unref(winTemConfig).winHeight&&unref(winTemConfig).winHeight.indexOf("%")>=0){
    sty["height"] = document.body.clientHeight*(parseFloat(unref(winTemConfig).winHeight)/100)+"px";
  }else{
    sty["height"] = document.body.clientHeight+"px";
  }
  return sty;
})

const loading=ref(true);
const iframeUrl=ref('');
if(unref(winTemConfig).pathUrl){
  iframeUrl.value=unref(winTemConfig).pathUrl;
}

const loadPage=function (){
  loading.value=false;
}
</script>

<style type="text/css" lang="less">
.noPaddingModal{
  .ant-modal-body{
    padding: 3px;
  }
}
</style>
